import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { log, NtapGlobalConstants, UIComponents, Util } from '@ntap/core';
import { combineLatest, Subscription } from 'rxjs';

import { ParentItemProviderService } from '@app/shared';

@Component({
  selector: 'app-fizicki-objekt-lista',
  templateUrl: './fizicki-objekt-lista.component.html',
  providers: [ParentItemProviderService]
})
export class FizickiObjektListaComponent implements OnInit, OnDestroy {
  INIT_COMP_ID = UIComponents.LISTVIEW;

  currentListViewName: string;
  currentListViewState: object | null = null;
  currentListViewStateFilter: object = {};

  routeChangeSubscription: Subscription;

  constructor(
    protected route: ActivatedRoute,
    protected parentItemProvider: ParentItemProviderService
  ) {}

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  ngOnDestroy(): void {
    this.unsubscribeFromRouteChange();
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.routeChangeSubscription = combineLatest([
      this.route.paramMap,
      this.parentItemProvider.parentItem$
    ]).subscribe(([, parentItem]: [params: any, parentItem: any]) => {
      log('param change');
      this.changeView('fizicki_objekt', parentItem);
    });
  }

  unsubscribeFromRouteChange(): any {
    log('Unsubsubscribe from route params');
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;
    this.currentListViewState = {
      //[Util.getFullAttrName('en.fizicki_objekt', 'pojavni_oblik_id')]:
      $parentId:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ],
      $itemType: 'en~pojavni_oblik',
      $parentType: 'en~pojavni_oblik',
      $parent: parentItem
    };
    this.currentListViewStateFilter = {};
  }
}
